export const webview = {
  webviewContent: 'Detta är en extern URL och den kommer att öppnas i ett nytt fönster. Öppna?',
  webviewButtonOpenTitle: 'Öppna',
  webviewButtonCopyTitle: 'Kopiera URL',
  webviewButtonOpenAgainTitle: 'Öppna igen',
  notifications: {
    urlCopied: 'URL kopierad!'
  }
}
